import { render, staticRenderFns } from "./AdminScene.vue?vue&type=template&id=c06fc19a&scoped=true"
import script from "./AdminScene.vue?vue&type=script&lang=js"
export * from "./AdminScene.vue?vue&type=script&lang=js"
import style0 from "./AdminScene.vue?vue&type=style&index=0&id=c06fc19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06fc19a",
  null
  
)

export default component.exports